// extracted by mini-css-extract-plugin
module.exports = {"root":"_1378TJU","link":"_1O8WsNx","linkTw":"_2jmGbhv","linkFb":"_3KNryv0"};